import React from "react"

import GenericImage from "./generic-image"

import "./team-carousel.scss"
import "font-awesome/css/font-awesome.min.css"

const teamMembers = [
  {
    name: "Binu K S",
    title: "CTO/CEO",
    picture: "team/binu.jpg",
    linkedinLink: "https://www.linkedin.com/in/binux/",
  },
  {
    name: "Sijeesh",
    title: "Design/Product",
    picture: "team/sijeesh.jpg",
    linkedinLink: "https://www.linkedin.com/in/sijeesh-balakrishnan-b64a5020/",
  },
  {
    name: "Shibu",
    title: "Lead Designer",
    picture: "team/shibu.jpg",
    linkedinLink: "https://www.linkedin.com/in/shibu-balakrishnan/",
  },

  {
    name: "Anshuman",
    title: "Lead Engineer",
    picture: "team/anshuman.jpg",
    linkedinLink: "https://www.linkedin.com/in/anshumansaagar/",
  },
  {
    name: "Arun",
    title: "Lead Engineer",
    picture: "team/arun.jpg",
    linkedinLink: "https://in.linkedin.com/in/aruncvf",
  },
  {
    name: "Kireeti",
    title: "Lead Engineer",
    picture: "team/kireeti.jpg",
    linkedinLink: "https://www.linkedin.com/in/kireeti-kuragayala/",
  },
  {
    name: "Karthigeyan",
    title: "Lead Engineer",
    picture: "team/karthigeyan.jpg",
    linkedinLink: "https://www.linkedin.com/in/shetty-karthik",
  },

  {
    name: "Ankit",
    title: "Software Engineer",
    picture: "team/ankit.jpg",
    linkedinLink: "https://www.linkedin.com/in/ankit-sharma-4a52068b",
  },

  {
    name: "Abhishek",
    title: "Software Engineer",
    picture: "team/abhishek.jpg",
    linkedinLink: "https://www.linkedin.com/in/abhisheksy",
  },

  {
    name: "Rishabh",
    title: "Software Engineer",
    picture: "team/rishabh.jpg",
    linkedinLink: "https://www.linkedin.com/in/rishabh-agrawal-48511967",
  },
  {
    name: "Bhuvan",
    title: "Software Engineer",
    picture: "team/bhuvan.jpg",
    linkedinLink: "https://www.linkedin.com/in/bhuvan-nagaraj",
  },
  {
    name: "Gaurav",
    title: "Software Engineer",
    picture: "team/gaurav.jpg",
    linkedinLink: "https://www.linkedin.com/in/gaurav-yadav-bbba5a182",
  },

  {
    name: "Sudev",
    title: "Software Engineer",
    picture: "team/sudev.jpg",
    linkedinLink: "https://www.linkedin.com/in/sudev-k-r/",
  },
  {
    name: "Aachman",
    title: "Software Engineer",
    picture: "team/aachman.jpg",
    linkedinLink: "https://www.linkedin.com/in/aachman-chandra-mehrishi-18a657b4",
  },
  {
    name: "Sreemon",
    title: "Designer/Engineer",
    picture: "team/sreemon.jpg",
    linkedinLink: "http://www.linkedin.com/in/sreemons",
  },
  {
    name: "Utkarsh",
    title: "Software Engineer",
    picture: "team/utkarsh-singh.jpg",
    linkedinLink: "https://www.linkedin.com/in/utkarsh-singh-22b790126/",
  },

  {
    name: "Deepak",
    title: "Software Engineer",
    picture: "team/deepak.jpg",
    linkedinLink: "https://www.linkedin.com/in/deepak-chauhan-687006166",
  },

  {
    name: "Deepa",
    title: "Software Engineer",
    picture: "team/deepa.jpg",
    linkedinLink: "https://www.linkedin.com/in/deepa1610",
  },

  {
    name: "Dhanish",
    title: "Software Engineer",
    picture: "team/dhanish.jpg",
    linkedinLink: "",
  },

  {
    name: "Akshit",
    title: "Software Engineer",
    picture: "team/akshit.jpg",
    linkedinLink: "https://www.linkedin.com/in/akshit-verma-792472152/",
  },

  {
    name: "Anup",
    title: "Software Engineer",
    picture: "team/anup.jpg",
    linkedinLink: "https://www.linkedin.com/in/anup-swarnkar-599a90144",
  },

  {
    name: "Utkarsh",
    title: "Software Engineer",
    picture: "team/utkarsh-sahu.jpg",
    linkedinLink: "https://www.linkedin.com/in/utkarsh--sahu/",
  },

  {
    name: "Sanjay",
    title: "Software Engineer",
    picture: "team/sanjay-beniwal.jpg",
    linkedinLink: "https://www.linkedin.com/in/sanjay-beniwal-8b036196/",
  },

  {
    name: "Lalit",
    title: "Software Engineer",
    picture: "team/lalit.jpg",
    linkedinLink: "",
  },
  {
    name: "Neelendu",
    title: "Software Engineer",
    picture: "team/neelendu.jpg",
    linkedinLink: "https://in.linkedin.com/in/neelendu-wadhwa-93a9681ab",
  },
  {
    name: "Kshirsagar",
    title: "Software Engineer",
    picture: "team/kshirsagar.jpg",
    linkedinLink: "https://www.linkedin.com/in/kshirsagar-naidu-043841198",
  },

  {
    name: "Vikash",
    title: "Software Engineer",
    picture: "team/vikash.jpg",
    linkedinLink: "https://www.linkedin.com/in/vikashyadav007/",
  },

  {
    name: "Karthik",
    title: "Software Engineer",
    picture: "team/karthik.jpg",
    linkedinLink: "https://www.linkedin.com/in/shetty-karthik",
  },

  {
    name: "Divyansh",
    title: "Software Engineer",
    picture: "team/divyansh.jpg",
    linkedinLink: "",
  },

  {
    name: "Ganesh",
    title: "Software Engineer",
    picture: "team/ganesh.jpg",
    linkedinLink: "https://www.linkedin.com/in/naga-sri-ganesh-nukala-973a9a153",
  },
  {
    name: "Sanjay",
    title: "Software Engineer",
    picture: "team/sanjay-d.jpg",
    linkedinLink: "https://www.linkedin.com/in/sanjay-d-15a500154/",
  },
  {
    name: "Aashish",
    title: "Software Engineer",
    picture: "team/aashish.jpg",
    linkedinLink: "https://www.linkedin.com/in/losdesperado",
  },
  {
    name: "Aakansha",
    title: "Software Engineer",
    picture: "team/aakansha.jpg",
    linkedinLink: "https://www.linkedin.com/in/aakansha-dhawan-33583511a",
  },
  {
    name: "Vyshakha",
    title: "Software Engineer",
    picture: "team/vyshakha.jpg",
    linkedinLink: "https://www.linkedin.com/in/vyshakha-m-s-707b06181/",
  },
]

const TeamPics = teamMembers.map((profile, i) => {
  return (
    <div className="profile">
      <div className="image-div">
        <GenericImage filename={profile.picture} />
        <div className="overlay">
          <div className="overlay-text">
            <h1>{profile.name}</h1>
            <p style={{ whiteSpace: "nowrap" }}>{profile.title}</p>
            <div className="text-center">
              <a className="fa fa-linkedin" href={profile.linkedinLink} target="_blank"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

const TeamCarousel = () => (
  <div className="team-carousel">
    <div className="profile-slider d-flex flex-row">{TeamPics}</div>
  </div>
)

export default TeamCarousel
